import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, sessionGeneration } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-400" data-testid="auth-loading">
        Checking session…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return <React.Fragment key={sessionGeneration}>{children}</React.Fragment>;
}
